//#region Libraries
import styled from "styled-components";
//#endregion
import { Column } from "components/styles";

export const Content = styled(Column)`
    min-height: calc(var(--min-height-without-header) - 160px);
    margin-top: 50px;
`;